export default "__VITE_ASSET__c6cd03d1__"